export enum ChargeState {
  EnteringData = "EnteringData",
  ChargeInProgress = "ChargeInProgress",
  ChargeTimeout = "ChargeTimeout",
  ChargeError = "ChargeError",
  Completed = "Completed",
}
